import React from "react";
import cccLogo from "../logo/ccclogo.png";

const AppFooter: React.FC = () => {
  return (
    <footer className="ccdp-footer">
      <div className="ccdp-footer-main">
        <div className="footer-column">
          <img
            src={cccLogo}
            alt="California Community Colleges"
            className="footer-logo"
          />
        </div>
        <div className="footer-column">
          <div></div>
        </div>
        <div className="footer-column">
          <div className="ccdp-footer-divider" />
          <a
            href="https://www.cccco.edu/Accessibility"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Accessibility
          </a>
        </div>
        <div className="footer-column">
          <div className="ccdp-footer-divider" />
          <a
            href="https://www.cccco.edu/Terms-of-Use"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Terms of Use
          </a>
        </div>
        <div className="footer-column">
          <div className="ccdp-footer-divider" />
          <a
            href="https://www.cccco.edu/Privacy-Statement"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Privacy Statement
          </a>
        </div>
        <div className="footer-column"></div>
        <div className="footer-column"></div>
      </div>
    </footer>
  );
};

export default AppFooter;
